export const GET_HOTEL_DETAIL_REQUEST = 'hotel/DETAIL_REQUEST';
export const GET_HOTEL_DETAIL_SUCCESS = 'hotel/DETAIL_SUCCESS';
export const GET_HOTEL_DETAIL_ERROR = 'hotel/DETAIL_ERROR';

export const getHotelDetailRequest = () => ({
  type: GET_HOTEL_DETAIL_REQUEST,
});

export const getHotelDetailSuccess = (payload) => ({
  type: GET_HOTEL_DETAIL_SUCCESS,
  payload,
});

export const getHotelDetailError = (payload) => ({
  type: GET_HOTEL_DETAIL_ERROR,
  payload,
});
